import { createContext } from "react";

interface Props {
  container?: HTMLDivElement | null;
  setContainer?: (container: HTMLDivElement | null) => void;
}

export const AppBarFiltersContainerContext = createContext<Props>({});
